import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import { memo } from "react";

const AppChart = ({ optionData, ...props }: AppChartProps) => {
  return (
    <HighchartsReact highcharts={Highcharts} options={optionData} {...props} />
  );
};

export default memo(AppChart);

type AppChartProps = React.ComponentProps<typeof HighchartsReact> & {
  optionData: Highcharts.Options;
};
